import { render, staticRenderFns } from "./ArrowBackPerfectMoney.vue?vue&type=template&id=36c6c508&"
import script from "./ArrowBackPerfectMoney.vue?vue&type=script&lang=js&"
export * from "./ArrowBackPerfectMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports